import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import PatientListPage from "@/pages/PatientListPage";
import NewPatientPage from "@/pages/NewPatientPage";
import EditPatientPage from "@/pages/EditPatientPage";
import PatientDetailPage from "@/pages/PatientDetailPage";
import NewWoundPage from "@/pages/NewWoundPage";
import WoundDetailPage from "@/pages/WoundDetailPage";
import NewWoundReportPage from "@/pages/NewWoundReportPage";
import EditWoundReportPage from "@/pages/EditWoundReportPage";
import SelectPatientForReportPage from "@/pages/SelectPatientForReportPage";
import SettingsPage from "@/pages/SettingsPage";
import AnamnesePage from "@/pages/AnamnesePage";
import BeratungPage from "@/pages/BeratungPage";
import TourenplanungPage from "@/pages/TourenplanungPage";
import AdminPage from "@/pages/AdminPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-3 border-teal-200 border-t-teal-700 rounded-full animate-spin" />
      </div>
    );
  }
  return user ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-3 border-teal-200 border-t-teal-700 rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<DashboardPage />} />
        <Route path="patienten" element={<PatientListPage />} />
        <Route path="patienten/neu" element={<NewPatientPage />} />
        <Route path="patienten/:id" element={<PatientDetailPage />} />
        <Route path="patienten/:id/bearbeiten" element={<EditPatientPage />} />
        <Route path="patienten/:patientId/neue-wunde" element={<NewWoundPage />} />
        <Route path="wunde/:id" element={<WoundDetailPage />} />
        <Route path="wunde/:woundId/neuer-bericht" element={<NewWoundReportPage />} />
        <Route path="wunde/:id/bericht/:reportId/bearbeiten" element={<EditWoundReportPage />} />
        <Route path="neuer-bericht" element={<SelectPatientForReportPage />} />
        <Route path="tourenplanung" element={<TourenplanungPage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="patienten/:patientId/anamnese" element={<AnamnesePage />} />
        <Route path="patienten/:patientId/beratung" element={<BeratungPage />} />
        <Route path="einstellungen" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
